import { Component, EventEmitter, Input, Output } from '@angular/core';

import { SharedModule } from '../../_shared/shared.module';
import { AbilityService } from '../../_shared/services/ability.service';
import { DataService } from '../../_shared/services/data.service';
import { UtilService } from '../../_shared/services/util.service';

import { Zone } from '../shared/zone.model';
import { ZoneService } from '../shared/zone.service';

@Component({
  selector: 'app-zone-list',
  templateUrl: './zone-list.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class ZoneListComponent {
  @Input() zones: Zone[];
  @Input() meta;
  @Input() loadingZones: boolean;
  @Input() defaultLanguage;

  @Output() private selectedZone = new EventEmitter<{
    zone: Zone;
    mode: string;
  }>();

  permissions = {
    canShow: this.abilityService.can('show_zone_accountadmin'),
    canUpdate: this.abilityService.can('update_zone_accountadmin'),
    canDestroy: this.abilityService.can('destroy_zone_accountadmin'),
  };

  filterCriteria = this.zoneService.getFilterCriteria();

  constructor(
    private zoneService: ZoneService,
    private abilityService: AbilityService,
    private dataService: DataService,
    public utilService: UtilService
  ) {}

  reloadZones() {
    this.filterCriteria = this.zoneService.getFilterCriteria();

    this.getZones();
  }

  // Referenced from app-search-text-input
  onSearched({ field, value }) {
    this.filterZones(field, value);
  }

  filterZones(field, value) {
    this.filterCriteria = this.utilService.setFilterCriteria(this.filterCriteria, field, value);

    this.getZones();
  }

  clearSearchForm() {
    this.reloadZones();
  }

  // Referenced from app-sort-by
  onSorted({ sortBy, sortDir }) {
    this.filterCriteria.page = 1;
    this.filterCriteria.sortDir = sortDir;
    this.filterCriteria.sortedBy = sortBy;

    this.getZones();
  }

  // Referenced from app-table-footer
  onSelectedPage({ page, offset }) {
    this.filterCriteria.page = page;
    this.filterCriteria.offset = offset;

    this.getZones();
  }

  selectZone(zone: Zone, mode = '') {
    if (!this.permissions.canShow) return;

    this.selectedZone.emit({ zone, mode });
  }

  changeZoneStatus(zone: Zone) {
    let successCallback = () => {
      this.utilService.changeItemRowStyle(zone.id);
    };

    this.dataService.changeItemStatus('zones', zone, successCallback);
  }

  deleteZone(zone: Zone) {
    let successCallback = () => {
      this.getZones();
    };

    const params = {
      title: 'DELETE_ZONE',
      message: 'SURE_TO_DELETE_ZONE',
      reason: 'DELETE_ITEM_REASON',
      requireConfirmation: true,
      successMsg: 'ZONE_DELETED',
    };

    this.dataService.deleteItem('zones', zone, successCallback, params);
  }

  private getZones() {
    this.filterCriteria.lang = this.defaultLanguage.lang;

    this.loadingZones = true;
    this.zoneService.getZones(this.filterCriteria).subscribe((response) => {
      this.zones = response.data;
      this.meta = response.meta;

      this.loadingZones = false;
    });
  }
}
